var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showFileComponent)?_c('cloud-files',{attrs:{"path":'/'+_vm.partyId,"tenantId":_vm.tenantId,"partyId":_vm.partyId,"allow-folders":false},on:{"restart":_vm.restart}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }